import React, { useState, useEffect } from 'react';
import { getBusinessProfileImage } from '../../utils/profileUtils';
import { DASHBOARD_PROFILE_AVATAR } from '../../config/dashboardAssets';

const ProfileAvatarFallback = ({ size, className = '' }) => {
  const sizeClasses = {
    xs: 'h-6 w-6',
    sm: 'h-7 w-7',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-20 w-20',
    '2xl': 'h-24 w-24',
  };

  return (
    <img
      src={DASHBOARD_PROFILE_AVATAR}
      alt=""
      className={`${sizeClasses[size] || sizeClasses.md} object-contain drop-shadow-[0_8px_20px_rgba(255,120,40,0.25)] ${className}`}
    />
  );
};

const BusinessProfileImage = ({
  user,
  size = 'md',
  className = '',
  alt = 'عکس پروفایل کسب و کار',
}) => {
  const profileImage = getBusinessProfileImage(user);
  const [imageFailed, setImageFailed] = useState(false);

  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-7 h-7',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20',
    '2xl': 'w-24 h-24',
  };

  const showFallback = !profileImage || imageFailed;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {showFallback ? (
        <ProfileAvatarFallback size={size} />
      ) : (
        <div className={`${sizeClasses[size]} overflow-hidden rounded-full bg-sky-wash`}>
          <img
            src={profileImage}
            alt={alt}
            className="h-full w-full object-cover"
            onError={() => setImageFailed(true)}
          />
        </div>
      )}
    </div>
  );
};

// کامپوننت جدید برای عکس پروفایل کسب و کار در محصولات
export const ProductBusinessProfileImage = ({ 
  businessData, 
  currentUser, 
  size = 'md', 
  className = '', 
  alt = 'عکس پروفایل کسب و کار'
}) => {
  const [profileImage, setProfileImage] = useState(null);
  
  // استفاده از profileUtils جدید
  useEffect(() => {
    const finalProfileImage = getBusinessProfileImage(currentUser, businessData);
    setProfileImage(finalProfileImage);
    
    console.log('ProductBusinessProfileImage: Profile image logic:', {
      businessName: businessData?.companyName,
      currentUserProfileImage: currentUser?.profileImage,
      sessionStorageProfileImage: sessionStorage.getItem('profileImage'),
      businessProfileImage: businessData?.profileImage,
      finalProfileImage: finalProfileImage,
      isUserLoggedIn: !!currentUser,
      shouldUseFallback: !businessData?.profileImage
    });
  }, [businessData, currentUser]);

  // گوش دادن به تغییرات عکس پروفایل
  useEffect(() => {
    const handleStorageChange = () => {
      if (currentUser) {
        const sessionProfileImage = sessionStorage.getItem('profileImage');
        if (sessionProfileImage) {
          setProfileImage(sessionProfileImage);
        }
      }
    };

    const handleProfileImageUpdate = (event) => {
      console.log('ProductBusinessProfileImage: Profile image update event received:', {
        event: event,
        detail: event.detail,
        businessName: businessData?.companyName,
        isUserLoggedIn: !!currentUser
      });

      if (currentUser) {
        const newProfileImage = event.detail?.profileImage || sessionStorage.getItem('profileImage');
        console.log('ProductBusinessProfileImage: Setting new profile image:', newProfileImage);
        if (newProfileImage) {
          setProfileImage(newProfileImage);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('profileImageUpdated', handleProfileImageUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('profileImageUpdated', handleProfileImageUpdate);
    };
  }, [businessData, currentUser]);
  // Size classes
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
    xl: 'w-12 h-12'
  };
  
  // Fallback icon sizes
  const iconSizes = {
    xs: 'w-2 h-2',
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
    xl: 'w-6 h-6'
  };

  console.log('ProductBusinessProfileImage Debug:', {
    businessName: businessData?.companyName,
    currentUserProfileImage: currentUser?.profileImage,
    businessProfileImage: businessData?.profileImage,
    finalProfileImage: profileImage,
    sessionStorageProfileImage: sessionStorage.getItem('profileImage'),
    size,
    businessData: businessData
  });

  return (
    <div className={`${sizeClasses[size]} rounded-full overflow-hidden bg-gradient-to-br from-sky-wash to-sky-bloom border-2 border-white shadow-sm ${className}`}>
      {profileImage ? (
        <img 
          src={profileImage} 
          alt={alt} 
          className="w-full h-full object-cover"
          onError={(e) => {
            console.error('Profile image failed to load:', profileImage);
            // If image fails to load, hide it and show fallback
            e.target.style.display = 'none';
            if (e.target.nextSibling) {
              e.target.nextSibling.style.display = 'flex';
            }
          }}
          onLoad={() => {
            console.log('Profile image loaded successfully:', profileImage);
          }}
        />
      ) : null}
      
      {/* Fallback icon - always present but hidden when image is shown
        // اگر هیچ عکس پروفایلی موجود نیست، از عکس پیش‌فرض استفاده کن
    // فقط در صورتی که کسب و کار عکس پروفایل نداشته باشه
      */}
      
      <div 
        className={`${profileImage ? 'hidden' : 'flex'} items-center justify-center bg-gradient-to-br from-sky-bloom to-sky-wash`}
        style={{ display: profileImage ? 'none' : 'flex' }}
      >
        <span className="text-signal text-xs font-bold">
          {businessData?.companyName ? 
            businessData.companyName.charAt(0).toUpperCase() : 
            'ک'
          }
        </span>
      </div>
    </div>
  );
};

export default BusinessProfileImage;
